import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Navigate } from "react-router-dom";
import { getTicket } from "../actions";

import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Spinner,
  Alert, // <--- Importamos Alert para que se vea bonito el error
} from "react-bootstrap";

const Login = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const [values, setValues] = useState({ rut: "", clave: "" });
  const [isLoading, setIsLoading] = useState(false);

  // Estado local para manejar si mostramos el error o no
  // (Esto sirve para ocultar el error cuando el usuario empieza a corregir el rut/clave)
  const [showError, setShowError] = useState(false);

  // Obtenemos el ticket del estado global
  // GRACIAS AL REDUCER QUE HICIMOS ANTES, ticket ahora es: { Retorno: -1, Mensaje: "...", ... }
  const ticket = useSelector((state) => state.ticket);

  // Efecto: Cada vez que recibimos un ticket nuevo, decidimos si mostramos error
  useEffect(() => {
    if (ticket && ticket.Retorno < 0) {
      setShowError(true);
    }
  }, [ticket]);

  // --- LOGICA DE AVANCE ---
  // Si Retorno es 0 o 1, navegamos al inicio (tests)
  if (ticket.Retorno == 0 || ticket.Retorno == 1) {
    return <Navigate to="/inicio" replace={true} />;
  }

  // Si Retorno es 2 (admin institución) o 3 (superusuario), navegamos al
  // selector de procesos.
  if (ticket.Retorno == 2 || ticket.Retorno == 3) {
    return <Navigate to="/seleccionar-proceso" replace={true} />;
  }

  const handleInputChangeRut = (event) => {
    // Ocultamos el error apenas el usuario empieza a escribir de nuevo
    setShowError(false);

    let _rut = event.target.value.toUpperCase();
    _rut = _rut.replace(/\./g, "").replace(/\s/g, "").replace(/-/g, "");
    if (_rut !== "" && _rut.length > 7)
      _rut = _rut.slice(-10, -1) + "-" + _rut.slice(-1);

    setValues({ ...values, [event.target.name]: _rut });
  };

  const handleInputChange = (event) => {
    setShowError(false); // Ocultar error al escribir
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setShowError(false); // Limpiamos errores previos

    const _params2 = {
      token: "c3649ba4e3a81815",
      function: "GetTicket",
      params: {
        id_origen: 0,
        usuario: values.rut,
        clave: values.clave,
      },
    };

    try {
      await dispatch(getTicket(_params2));
      // No necesitamos lógica aquí, el useEffect o el if(ticket.Retorno === 0)
      // manejarán el resultado visualmente.
    } catch (error) {
      console.error("Error de red:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container fluid="xl">
      <Row className="mt-5">
        <Form
          className="d-grid gap-2 col-6 col-xs mx-auto"
          onSubmit={handleSubmit}
        >
          {/* ... Inputs de RUT y Clave (Igual que antes) ... */}
          <Form.Group className="mb-3" controlId="rut">
            <Form.Label>Ingrese su RUT</Form.Label>
            <Form.Control
              className="form-control form-control-sm"
              type="text"
              value={values.rut}
              name="rut"
              onChange={handleInputChangeRut}
              disabled={isLoading}
            />
            <span className="text-danger">
              Ejemplo: 12345678-9 (Sin Puntos)
            </span>
          </Form.Group>

          <Form.Group className="mb-5 mt-3" controlId="clave">
            <Form.Label>Ingrese su clave</Form.Label>
            <Form.Control
              className="form-control form-control-sm"
              type="password"
              value={values.clave}
              name="clave"
              onChange={handleInputChange}
              disabled={isLoading}
            />
          </Form.Group>

          {/* --- ZONA DE MENSAJES DE ERROR --- */}
          <Row className="mt-2">
            <Col>
              {showError && ticket.Retorno < 0 && (
                <Alert variant="danger" className="text-center">
                  {/* Aquí mostramos el mensaje que viene de la API */}
                  {ticket.Mensaje || "Error desconocido"}
                </Alert>
              )}
            </Col>
          </Row>

          <Row className="mt-2">
            <Col className="text-center">
              <Button
                className="xz-btn-ok"
                variant="primary"
                size="lg"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{" "}
                    Validando...
                  </>
                ) : (
                  "Ingresar"
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      </Row>
    </Container>
  );
};

export default Login;
